// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__11i5V","Open":"SideDrawer_Open__11IiV","Close":"SideDrawer_Close__22AuV","Logo":"SideDrawer_Logo__11Xpt"};